export default __webpack_public_path__ + "img/5608e8ef6146a474a7056ea6730c1f15.svg";